// import { backendConfigDev } from "./backend-config-dev";
import { backendConfigTest } from "./backend-config-test";

export const GoogleMapsAPI = 'AIzaSyBLIJSaqfzhl8X32e9FzLNlqKvhQ4suLuA';

export const backendConfig = backendConfigTest;
// export const backendConfig = backendConfigDev;
